const processRefund = function () {
  window.open(
    $("input[data-refund-uri]").val() +
      "?amount=" +
      $("input[data-refund-amount]").val(),
    "_self",
  );
};

const showOrHideIntermediaryFields = function (toggleInput) {
  let inputDiv = $("[data-intermediary-fields]");
  let inputDiv2 = $("[parent-id-field]");
  if (toggleInput.val() == "true") {
    inputDiv.removeClass("hidden");
    inputDiv2.addClass("hidden");
  } else {
    inputDiv.addClass("hidden");
    inputDiv2.removeClass("hidden");
  }
};

$(function () {
  $('a[data-toggle="tab"]').on("show.bs.tab", function (e) {
    localStorage.setItem("activeTab", $(e.target).attr("href"));
  });
  let activeTab = localStorage.getItem("activeTab");
  if (activeTab) {
    $('#myTab a[href="' + activeTab + '"]').tab("show");
  }

  $("a[data-refundbutton]").click(function (e) {
    let popupDiv = $("#refund-popup");
    popupDiv.dialog({
      resizable: false,
      height: 200,
      width: 600,
      modal: true,
      buttons: {
        Refund: function () {
          $(this).dialog("close");
          processRefund();
        },
        Cancel: function () {
          $(this).dialog("close");
        },
      },
    });
    $("input[data-refund-amount]").keypress(function (event) {
      if (event.which == 13) {
        popupDiv.dialog("close");
        processRefund();
      }
    });
  });

  $('[data-toggle="tooltip"]').tooltip();

  $('input[name="entity[transaction][intermediary]"]').change(function () {
    showOrHideIntermediaryFields($(this));
  });

  $('input[name="transaction[intermediary]"]').change(function () {
    showOrHideIntermediaryFields($(this));
  });
});
